import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setCurrentRedaction } from 'store/AdminClient/RedactionData';
import { transformToSemanticGap } from 'helpers/FormatKeywordsHelper';
import axiosPrivate from 'config/axiosPrivate';
import { removeStrongTags } from 'utils/StringUtils';

export const useAdminClientDeliverText = ({
  t,
  textType,
  combinedKeywords,
  setErrorSuccessMsg,
  setIsSuccess,
  setErrorSuccess,
  titleTag,
  metaDescriptionTag,
  setIsFetchLoading,
  actualHtmlContent,
  actualTextContent,
  semanticScore,
  initialHtmlContent,
  initialTextContent,
  keyword,
  textTitle,
  actualTextWordCount,
  initialTextWordCount,
  url,
  websites,
  setErrorSuccessImg,
  redactionId,
  formData,
  currentContentScore,
}) => {
  const dispatch = useDispatch();
  const [isTextDelivered, setIsTextDelivered] = useState(false);

  const deliverText = useCallback(async (demande, finalHtmlContent) => {
    try {
      setIsFetchLoading(true);


      const validTypes = ['NON_TRANSLATED', 'COMBINED', 'TRANSLATED'];
      const documentType = formData?.type && validTypes.includes(formData.type)
        ? formData.type
        : 'NON_TRANSLATED';

      const rawHtmlContent = finalHtmlContent || actualHtmlContent || '';
      const cleanedHtmlContent = removeStrongTags(rawHtmlContent);
      const deliverPayload = {
        keyword: keyword || '',
        url: url || '',
        titleTag: titleTag || '',
        metaDescriptionTag: metaDescriptionTag || '',
        contentScore: currentContentScore || formData?.contentScore || formData?.initialScoreData || null,
        actualTextContent: actualTextContent || '',
        initialTextContent: initialTextContent || '',
        actualHtmlContent: cleanedHtmlContent,
        initialHtmlContent: initialHtmlContent || '',
        activeInitialText: formData?.activeInitialText !== undefined ? formData.activeInitialText : true,
        numberWords: actualTextWordCount || 0,
        type: documentType,

        internalLinking: websites || '',
        aiAgentId: formData?.aiAgentId || '',
      };

      console.log('📤 Livraison AdminClient vers /texts/external/{id}/deliver:', deliverPayload);


      const response = await axiosPrivate.put(
        `/texts/external/${redactionId}/deliver`,
        deliverPayload
      );

      const result = response.data || {};

      // Mise à jour du Redux store AdminClient
      dispatch(
        setCurrentRedaction({
          ...formData,
          id: result.id || redactionId,
          keyword: result.keyword || keyword || '',
          url: result.url || url || '',
          titleTag: result.titleTag || titleTag || '',
          metaDescriptionTag: result.metaDescriptionTag || metaDescriptionTag || '',
          actualTextContent: result.actualTextContent || actualTextContent || '',
          actualHtmlContent: result.actualHtmlContent || cleanedHtmlContent,
          initialTextContent: result.initialTextContent || initialTextContent || '',
          initialHtmlContent: result.initialHtmlContent || initialHtmlContent || '',
          semanticGap: result.semanticGap || [],
          internalLinking: result.internalLinking || websites || '',
          delivered: result.delivered !== undefined ? !!result.delivered : true,
          validated: !!result.validated,
          deployed: !!result.deployed,
          inRevision: !!result.inRevision,
          deliveredAt: result.deliveredAt || new Date().toISOString(),
          contentScore: result.contentScore || currentContentScore || formData?.contentScore || null,
        })
      );

      setErrorSuccessMsg(t('Texte livré avec succès'));
      setErrorSuccessImg('/Images/succes.png');
      setIsSuccess(true);
      setErrorSuccess(true);
      setIsTextDelivered(true);

      return result;
    } catch (error) {
      console.error('🔍 AdminClient deliverText error:', error);

      const errorMessage = error.response?.data?.message
        || error.message
        || t('Erreur lors de la livraison');

      setErrorSuccessMsg(errorMessage);
      setIsSuccess(false);
      setErrorSuccess(true);

      throw error;
    } finally {
      setIsFetchLoading(false);
    }
  }, [
    redactionId,
    textTitle,
    keyword,
    url,
    titleTag,
    metaDescriptionTag,
    actualTextContent,
    actualHtmlContent,
    initialTextContent,
    initialHtmlContent,
    combinedKeywords,
    websites,
    actualTextWordCount,
    initialTextWordCount,
    textType,
    formData,
    currentContentScore,
    setIsFetchLoading,
    setErrorSuccessMsg,
    setErrorSuccessImg,
    setIsSuccess,
    setErrorSuccess,
    dispatch,
    t,
  ]);

  return {
    deliverText,
    isTextDelivered,
    setIsTextDelivered,
  };
};
